import TableSortProvider from "providers/TableSortProvider";
import { programsTableConfig } from "../ProgramsTable/ProgramsTable.config";
import SearchTextProvider from "providers/SearchTextProvider";
import ListOptionsProvider from "providers/ListOptionsProvider";
import FilterAthletesOrGroupsProvider from "./FilterAthletesOrGroupsProvider";

interface ProgramsFiltersProvidersProps {
  children?: React.ReactNode;
}

/**
 * @description Wraps the children components with necessary providers for managing filters and sorting in the Programs section.
 */
function ProgramsFiltersProviders(props: ProgramsFiltersProvidersProps) {
  return (
    <>
      <ListOptionsProvider>
        <SearchTextProvider>
          <TableSortProvider
            initialSortKey={programsTableConfig.defaultSortKey}
            initialDirection={programsTableConfig.defaultSortDirection}
          >
            <FilterAthletesOrGroupsProvider>{props.children}</FilterAthletesOrGroupsProvider>
          </TableSortProvider>
        </SearchTextProvider>
      </ListOptionsProvider>
    </>
  );
}

export default ProgramsFiltersProviders;
